export default function clearField(value) {
  value("");
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/clearField', clearField);